import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import {Link} from 'react-router-dom'
import { AppBar, Toolbar, Grid, Box,  } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../assets/invlogo.png'

const useStyles = makeStyles({
  list: {
    width: 230,
  },
  fullList: {
    width: 'auto',
  },
  color: {
    backgroundColor: '#02192D',
},
reslogo: {
    height: '25px',
    paddingTop: '8px'   
},
reslink: {
    textDecoration: 'none',
    color: '#02192D',
    fontWeight: 'bold',
    fontSize: '17px',
    fontFamily: 'Poppins',
},
reslink2: {
    textDecoration: 'none',
    color: '#02192D',
    fontSize: '16px',
    fontFamily: 'Poppins',
},

});

export default function TemporaryDrawer() {
  const classes = useStyles();
  const [state, setState] = React.useState({    
    left: false,    
  });

  const toggleDrawer = (anchor, open) => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const list = anchor => (
    <div className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>                           
              <ListItem key = {1} button divider>
             <Link to="/hoistrings" className={classes.reslink}>Hoist Rings</Link></ListItem>
               {/* <ListItem key = {2} button divider>
               <Link to="/technicalresources" className={classes.reslink}>Technical Resources</Link></ListItem> */}
               <ListItem key = {3} button divider>
               <Link to="/onlinecerts" className={classes.reslink}>Online Certs</Link></ListItem>                            
               <ListItem key = {5} button divider></ListItem>
               <ListItem key = {6} button divider> 
               <Link to="/" className={classes.reslink2} >Home</Link> </ListItem>
               <ListItem key = {7} button divider>
               <a href="#contact" className={classes.reslink2}>Contact</a></ListItem> 
               <ListItem key = {8} button divider>
               <a href="#about" className={classes.reslink2}>About</a> </ListItem>
               <ListItem key = {9} button divider>
               <a href="#wheretobuy" className={classes.reslink2}>Where to Buy</a> </ListItem>
               <ListItem key = {10} button divider>
               <a href="#products" className={classes.reslink2}>Products</a> </ListItem>
              
      </List>
    </div>
  );

  return (
    <div>             
       <Box	display={{ xs: 'block', md: 'block', sm: 'block', lg: 'none' }}  >
      {['left'].map(anchor => (
        <React.Fragment key={anchor}>
            <AppBar  className={classes.color} style={{backgroundColor: "#02192D"}}>        
          <Toolbar >
            <Grid container direction = "row" justify = "space-between" style={{justifyContent: "space-between"}} >            
              <MenuIcon style={{fontSize:'30px', color: 'white', paddingTop:'6px'}} onClick={toggleDrawer(anchor, true)}>{anchor}/></MenuIcon>          
          <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
            {list(anchor)}
          </Drawer>
          <Link to="/" style={{justifyContent: "flex-end"}}> 
          <img src={logo} className={classes.reslogo} alt=""/ ></Link>
          </Grid>
          </Toolbar>
        </AppBar>
        </React.Fragment>
      ))}
      </Box>
    </div>
  );
}